import { useCallback, useEffect } from 'react'
import { useLazyQuery, useReactiveVar } from '@apollo/client'

import { useLoading, useServerError } from 'shared/hooks'

import { useUpdateInfoMessage } from 'modules/Messages/graphql/mutations/updateInfoMessage'
import { GET_INFO_MESSAGE } from 'modules/Messages/graphql/queries'
import { messageVar } from 'modules/Messages/store'
import { isFirstLoginVar } from 'modulesCommon/store'
import { useOktaAuth } from '@okta/okta-react'

const useMessages = () => {
  const { authState } = useOktaAuth()

  const isFirstLogin = useReactiveVar(isFirstLoginVar)
  const message = useReactiveVar(messageVar)

  const [getInfoMessage, { data: messageData, loading: messageLoading, error: messageError }] =
    useLazyQuery(GET_INFO_MESSAGE)
  const { mutate, loading: updateInfoMessageLoading } = useUpdateInfoMessage()

  const closeDialog = useCallback(() => isFirstLoginVar(false), [])
  const updateInfoMessage = useCallback(
    (data) => {
      mutate({ variables: { input: data } })
    },
    [mutate]
  )

  useEffect(() => {
    if (authState?.isAuthenticated) getInfoMessage()
  }, [authState, getInfoMessage])

  useEffect(() => {
    if (messageData) messageVar(messageData.getInfoMessage)
  }, [messageData])

  useLoading({ isLoading: messageLoading || updateInfoMessageLoading })
  useServerError([messageError])

  return { isFirstLogin, message, updateInfoMessage, closeDialog, updateInfoMessageLoading }
}

export default useMessages
